module.exports = __webpack_public_path__ + "img/1-6.f0d1510e.svg";